import { render } from "./TourDetailBanner.vue?vue&type=template&id=0ec3777a"
import script from "./TourDetailBanner.vue?vue&type=script&lang=js"
export * from "./TourDetailBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__